export default "__VITE_PUBLIC_ASSET__f11474f5__"